/*
 * @Author: clive.cao
 * @Date: 2020-08-13 11:16:36
 * @LastEditTime: 2020-10-15 09:15:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/assets/lib/sessionHelper.js
 */
class Storage {
    constructor(type){
      this.type = type || 'sessionStorage'
    }
  /**
     * 设置本地存储
     * @param {string} name keyname
     * @param {mix} content value
     */
    set(obj = {}){
      if (!Object.keys(obj).length) return;
      Object.keys(obj).map(e=>{
        if (!e) return;
        if (typeof obj[e] !== 'string') {
            obj[e] = JSON.stringify(obj[e]);
        }
        window[this.type].setItem(e, obj[e]);
      })
    }
    /**
     * 设置本地存储
     * @param {string} name keyname
     * @param {mix} content value
     */
    setSingle(key,value){
        if (!key) return;
        if (typeof value !== 'string') {
            value = JSON.stringify(value);
        }
        window[this.type].setItem(key, value);
    }
    get(...names){
        if(names.filter(e=>(typeof e!=='string' || e.replace(/\s*/g,'')==='' )).length>0) return;
        let value = {};
        names.map(e=>{
            if (!e) return;
            value[e] = window[this.type].getItem(e);
        })
        return value
    }
    /**
     * 获取本地存储
     * @param {string} name
     */
    getSingle(name){
      if (!name) return;
      try{
        return JSON.parse(window[this.type].getItem(name))
      } catch(err){
        return window[this.type].getItem(name);
      }
    }
    /**
     * 移除本地数据
     * @param {string} name
     */
    remove(name){
      if (!name) return;
      window[this.type].removeItem(name);
    }
}

export default {
  session: new Storage(),
  local: new Storage('localStorage')
}


// WEBPACK FOOTER //
// ./src/assets/lib/storageHelper.js